import Location from '../../../hooks/Location'
import useLogRecordOpen from '../../../hooks/useLogRecordOpen'
import { useContext } from 'react'
import { useFirestoreID, useFirestoreOrderBy } from '../../../firebase/useFirestore'
import { SavedIcon } from '../../../StateManagment/SavedIcon'
import { db } from '../../../firebase/config'
import { PersonaEffectCard } from '../Dashboard/PersonaEffects'
import useEffectiveResearchIds from '../../../hooks/research/useEffectiveResearchIds'
import ReadOnlyGuard from '../../common/ReadOnlyGuard'
import { goalEffectIds, goalTitle } from '../../../helpers/goalsHelpers/personaGoalFields'

const PersonaGoalDetail = () => {
    // Context
    const [, setSaved] = useContext(SavedIcon)

    // Hooks
    const personaId = Location()[3]
    // Auditlog: dit scherm toont dossiergegevens, dus het telt als raadpleging.
    useLogRecordOpen('persona', personaId)
    const goalId = Location()[4]

    // Firestore
    const goals = useFirestoreID('PersonaGoals', goalId ? goalId : '')
    const personas = useFirestoreID('Personas', personaId ? personaId : '')
    const effects = useFirestoreOrderBy('OutputEffects', 'Position', 'asc') || []
    const effectNameById = Object.fromEntries(effects.map(e => [e.ID, e.Effect]))

    const goal = goals && goals[0]
    const persona = personas && personas[0]

    // Handmatig gekoppeld plus elk onderzoek dat voor alle medewerkers geldt;
    // vóór de vroege return, want een hook hoort elke render te draaien.
    // AI-CONTEXT: See docs/features/automatische-deelname-onderzoek.md
    const { ids: researchIds } = useEffectiveResearchIds({ kind: 'persona', linkedIds: persona?.Research })

    const updateGoal = (field, value) => {
        if (!goal) return
        db.collection('PersonaGoals').doc(goal.docid).update({ [field]: value })
            .then(() => setSaved('flex'))
    }

    const toggleEffect = (effectId) => {
        if (!goal) return
        // Uit elke opslagvorm; geschreven wordt altijd naar EffectIDs, dat daarna voorgaat.
        const current = goalEffectIds(goal)
        const next = current.includes(effectId)
            ? current.filter(id => id !== effectId)
            : [...current, effectId]
        updateGoal('EffectIDs', next)
    }

    if (!goal || !persona) return null

    const linkedIds = goalEffectIds(goal)
    const linkedEffects = effects.filter(e => linkedIds.includes(e.ID))

    return (
        <div className="main">
            <div className="main-container">
                <div className="page-header">
                    <h1>Doel aanpassen</h1>
                </div>

                <ReadOnlyGuard edit="personas.edit">
                    <div className="dashboard-container">
                        <h2>Titel</h2>
                        <input
                            type="text"
                            defaultValue={goal.Title || goal.Goal || ''}
                            // Het oudste soort doel heeft geen eigen titel en heet naar zijn effect.
                            placeholder={goalTitle(goal, effectNameById)}
                            onChange={(e) => updateGoal('Title', e.target.value)}
                        />

                        <h2>Status</h2>
                        <select
                            value={goal.Status || 'niet-bereikt'}
                            onChange={(e) => updateGoal('Status', e.target.value)}
                        >
                            <option value="niet-bereikt">Niet bereikt</option>
                            <option value="bereikt">Bereikt</option>
                        </select>

                        <h2>Beschrijving</h2>
                        <textarea
                            className="persona-goal-description"
                            defaultValue={goal.Description}
                            placeholder="Beschrijving..."
                            onChange={(e) => updateGoal('Description', e.target.value)}
                        />
                    </div>

                    <div className="dashboard-container">
                        <h2>Gekoppelde effecten</h2>
                        <div className="persona-goal-effects-picker">
                            {effects.map(effect => (
                                <label key={effect.ID} className="persona-goal-effect-option">
                                    <input
                                        type="checkbox"
                                        checked={linkedIds.includes(effect.ID)}
                                        onChange={() => toggleEffect(effect.ID)}
                                    />
                                    <span>{effect.Effect}</span>
                                </label>
                            ))}
                        </div>
                    </div>
                </ReadOnlyGuard>

                {linkedEffects.length > 0 && (
                    <>
                        <h2>Voortgang</h2>
                        <div className="new-dashboard-grid">
                            {linkedEffects.map(effect => (
                                <PersonaEffectCard
                                    key={effect.ID}
                                    effect={effect}
                                    researchIds={researchIds}
                                    personaId={persona.ID}
                                />
                            ))}
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}

export default PersonaGoalDetail
